export default function embedWindow() {
    const windows = document.querySelectorAll('.gh-window');
    if (!windows.length) return;

    windows.forEach(win => {
        const title = win.dataset.title || '';
        const iframe = win.querySelector('iframe');
        const src = iframe ? iframe.src : '#';

        // Build title bar
        const titleBar = document.createElement('div');
        titleBar.className = 'gh-window-titlebar';

        const dots = document.createElement('div');
        dots.className = 'gh-window-dots';
        dots.innerHTML = '<span></span><span></span><span></span>';

        const titleEl = document.createElement('span');
        titleEl.className = 'gh-window-title';
        titleEl.textContent = title;

        const actions = document.createElement('div');
        actions.className = 'gh-window-actions';

        const fullscreenBtn = document.createElement('button');
        fullscreenBtn.className = 'gh-window-btn';
        fullscreenBtn.setAttribute('aria-label', 'Fullscreen');
        fullscreenBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>';

        const newTabBtn = document.createElement('a');
        newTabBtn.className = 'gh-window-btn';
        newTabBtn.href = src;
        newTabBtn.target = '_blank';
        newTabBtn.rel = 'noopener';
        newTabBtn.setAttribute('aria-label', 'Open in new tab');
        newTabBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';

        actions.appendChild(fullscreenBtn);
        actions.appendChild(newTabBtn);

        titleBar.appendChild(dots);
        titleBar.appendChild(titleEl);
        titleBar.appendChild(actions);

        win.insertBefore(titleBar, win.firstChild);

        // Fullscreen toggle
        fullscreenBtn.addEventListener('click', () => {
            const isFullscreen = win.classList.contains('gh-window-fullscreen');
            win.classList.toggle('gh-window-fullscreen');
            document.body.style.overflow = isFullscreen ? '' : 'hidden';
            fullscreenBtn.setAttribute('aria-label', isFullscreen ? 'Fullscreen' : 'Exit fullscreen');
        });

        // Escape to exit fullscreen
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && win.classList.contains('gh-window-fullscreen')) {
                win.classList.remove('gh-window-fullscreen');
                document.body.style.overflow = '';
            }
        });
    });
}
